/**
 * i18n bootstrap — FR (default) / EN.
 * Preference: localStorage key `palestre_locale`.
 * Number/date formatting stays Swiss (de-CH) regardless of UI language.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonFr from './locales/fr/common.json';
import commonEn from './locales/en/common.json';
import navFr from './locales/fr/nav.json';
import navEn from './locales/en/nav.json';
import authFr from './locales/fr/auth.json';
import authEn from './locales/en/auth.json';
import settingsFr from './locales/fr/settings.json';
import settingsEn from './locales/en/settings.json';
import peopleFr from './locales/fr/people.json';
import peopleEn from './locales/en/people.json';
import financeFr from './locales/fr/finance.json';
import financeEn from './locales/en/finance.json';
import rentabiliteFr from './locales/fr/rentabilite.json';
import rentabiliteEn from './locales/en/rentabilite.json';
import scenariiFr from './locales/fr/scenarii.json';
import scenariiEn from './locales/en/scenarii.json';
import cockpitFr from './locales/fr/cockpit.json';
import cockpitEn from './locales/en/cockpit.json';
import adminFr from './locales/fr/admin.json';
import auditFr from './locales/fr/audit.json';
import adminEn from './locales/en/admin.json';
import auditEn from './locales/en/audit.json';
import printFr from './locales/fr/print.json';
import printEn from './locales/en/print.json';
import phrasesFr from './locales/fr/phrases.json';
import phrasesEn from './locales/en/phrases.json';

export const LOCALE_KEY = 'palestre_locale';
export const SUPPORTED_LOCALES = ['fr', 'en'];
export const DEFAULT_LOCALE = 'fr';

export function readStoredLocale() {
  try {
    const v = localStorage.getItem(LOCALE_KEY);
    if (SUPPORTED_LOCALES.includes(v)) return v;
  } catch (_) { /* ignore */ }
  return DEFAULT_LOCALE;
}

export function writeStoredLocale(locale) {
  const next = SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
  try {
    localStorage.setItem(LOCALE_KEY, next);
  } catch (_) { /* ignore */ }
  return next;
}

const resources = {
  fr: {
    common: commonFr,
    nav: navFr,
    auth: authFr,
    settings: settingsFr,
    people: peopleFr,
    finance: financeFr,
    rentabilite: rentabiliteFr,
    scenarii: scenariiFr,
    cockpit: cockpitFr,
    admin: adminFr,
    audit: auditFr,
    print: printFr,
    phrases: phrasesFr,
  },
  en: {
    common: commonEn,
    nav: navEn,
    auth: authEn,
    settings: settingsEn,
    people: peopleEn,
    finance: financeEn,
    rentabilite: rentabiliteEn,
    scenarii: scenariiEn,
    cockpit: cockpitEn,
    admin: adminEn,
    audit: auditEn,
    print: printEn,
    phrases: phrasesEn,
  },
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: readStoredLocale(),
    fallbackLng: DEFAULT_LOCALE,
    defaultNS: 'common',
    ns: [
      'common', 'nav', 'auth', 'settings',
      'people', 'finance', 'rentabilite', 'scenarii',
      'cockpit', 'admin', 'print', 'phrases',
    ],
    interpolation: { escapeValue: false },
    returnNull: false,
  });
}

export async function setAppLocale(locale) {
  const next = writeStoredLocale(locale);
  await i18n.changeLanguage(next);
  return next;
}

export default i18n;
